var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#818E9C",
    fillRule: "evenodd",
    d: "M2.852 1.87a.694.694 0 1 0-.982.982l2.97 2.97a13.507 13.507 0 0 0-3.09 3.85.695.695 0 0 0-.01.639l.621-.31-.62.31v.002l.003.005.008.016.028.053c.024.046.06.11.105.192a14.353 14.353 0 0 0 1.966 2.674c1.36 1.451 3.441 2.997 6.15 2.997h.01a7.688 7.688 0 0 0 4.035-1.222l3.102 3.102a.694.694 0 1 0 .982-.982l-3.514-3.514-2.65-2.65-.005-.005-2.94-2.94-.005-.005-2.65-2.65L2.852 1.87Zm10.184 12.148-1.612-1.612a2.784 2.784 0 0 1-2.516.222 2.779 2.779 0 0 1-1.313-4.051l-1.77-1.77a12.118 12.118 0 0 0-2.67 3.195 12.972 12.972 0 0 0 1.71 2.3c1.242 1.326 2.98 2.557 5.13 2.56a6.298 6.298 0 0 0 3.041-.844ZM8.631 9.613a1.389 1.389 0 0 0 1.757 1.757L8.63 9.613Zm.07-4.326c.425-.1.86-.149 1.298-.148H10c2.153 0 3.892 1.232 5.136 2.558A12.975 12.975 0 0 1 16.846 10a12.24 12.24 0 0 1-1.238 1.77.694.694 0 1 0 1.063.893 13.55 13.55 0 0 0 1.58-2.335.695.695 0 0 0 .01-.637l-.004-.008c.011.024.003.008.003.008v-.002l-.001-.001-.002-.005-.008-.015a12.835 12.835 0 0 0-.536-.911 14.354 14.354 0 0 0-1.564-2.009c-1.36-1.45-3.44-2.997-6.148-2.997a7.028 7.028 0 0 0-1.617.185.694.694 0 0 0 .316 1.352ZM10 3.75h.001Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOff);
export default __webpack_public_path__ + "static/media/eye-off.c92f892f26348824e591b7d343bc062d.svg";
export { ForwardRef as ReactComponent };